export default __webpack_public_path__ + "static/backgroundHomeTV-c3d0871c35d9339fc8e608f3a50cb6a8.webp";